module.exports = __webpack_public_path__ + "img/share.949e14e8.png";